module.exports = __webpack_public_path__ + "img/logo.a80f2b29.svg";